import { useTranslation } from "react-i18next";
import { useState } from "react";
import { GetAllCompanyDto } from "../../../../types/api/api-types";
import { BillingEntityPaymentElem } from "./billingEntityPaymentElemProps";
import { ListEditModal } from "./listEditModal";

type GeneralInfoPaymentProps = {
  company?: GetAllCompanyDto;
};

export const GeneralInfoPayment = ({ company }: GeneralInfoPaymentProps) => {
  const { t } = useTranslation("boClients");
  const [editing, setEditing] = useState(0);

  const handleEdit = (editIndex: number) => {
    setEditing(editIndex);
  };

  const displayModal = () => {
    switch (editing) {
      case 1:
        return <ListEditModal closeModal={() => setEditing(0)} company={company!} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex w-full flex-1 flex-col gap-6 md:px-8">
      <div className="flex flex-row items-center justify-between gap-2 border-0 border-b border-gray-200 pb-5">
        <div className="items-left flex flex-col gap-2">
          <h2 className="text-lg font-semibold">{t("profileGeneralInfoPayment.title")}</h2>
          <p className="text-sm text-gray-600">{t("profileGeneralInfoPayment.subtitle")}</p>
        </div>
        <button
          onClick={() => handleEdit(1)}
          className="h-fit rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-200 hover:text-gray-800"
        >
          {t("profileGeneralInfoPayment.edit")}
        </button>
      </div>
      <div className="flex flex-col gap-6">
        {company?.billingEntities.map((billingEntity, index) => (
          <BillingEntityPaymentElem
            key={index}
            isDefault={billingEntity.isDefault}
            name={billingEntity.companyName}
            mode={billingEntity.paymentMethod}
          />
        ))}
      </div>
      {displayModal()}
    </div>
  );
};
